<template><svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
	<circle cx="4" cy="6" r="1.5" />
	<path d="M14,6l-2-2l-1-1H1v10h14V7L14,6z M11,4v3h3v4L9.5,6.5l-3,4l-2-2L2,12V4H11z" />
</svg>
</template>